import React, { useState, useEffect } from "react";
import {
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  FormDataConsumer,
  useTranslate
} from "react-admin";
import { Box } from "@mui/material";

import { generateFilterFieldLocale } from "../../../core/resource/factory";
import alasql from "alasql";

const conditionChoices = [
  { id: "gt", name: "أكبر من" },
  { id: "gte", name: "أكبر من أو يطابق" },
  { id: "lt", name: "أصغر من" },
  { id: "lte", name: "أصغر من أو يطابق" },
  { id: "eq", name: "يطابق" },
];

const CustomDynamicEscalationInput = ({ source }) => {
  const [filterData, setFilterData] = useState([]);
  const translate = useTranslate();


  useEffect(() => {
    const role = localStorage.getItem('role');

    const roleKey = `role_${role}`;
    const data = alasql(`
      SELECT watched_column, source_name, filter_widget_type, input_widget_type, field_meta, annotation
      FROM resources
      WHERE resource_name = 'accidents_accident_log' 
      AND (${roleKey} = 'write' OR ${roleKey} = 'read')
    `);

   



    setFilterData(data);
  }, []);



  const columnChoices = filterData.map((f) => ({
    id: f.source_name,
    name: translate(`resources.accidents_accident_log.fields.${f.source_name}`),
  }));

  const renderFilterField = (f, index = 0) => {
    f.input_widget_type = f.filter_widget_type;
    // Provide proper parameters to generateFilterFieldLocale
    return generateFilterFieldLocale(f, index, undefined, undefined, undefined, `escalation-${f.source_name}-${index}`);
  };

  return (
    <ArrayInput source={source} label="شروط التصعيد">
      <SimpleFormIterator>

        
        <FormDataConsumer>
          {({ scopedFormData }) => {


            const selectedColumn = scopedFormData?.column;

            const columnConfig = filterData.find(
              (f) => f.source_name === selectedColumn
            );


            return (
              <Box display="flex" gap={2} alignItems="center">
                <SelectInput
                  source="column"
                  label="الحقل"
                  choices={columnChoices}
                />
                <SelectInput
                  source="condition"
                  label="المعادلة"

                  choices={conditionChoices}
                />
                {selectedColumn && columnConfig
                  ? renderFilterField({
                      ...columnConfig,
                      source_name: "value",
                      label: "القيمة",
                    })
                  : null}
              </Box>
            );
          }}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default CustomDynamicEscalationInput;
